import React from 'react';
import { InputAdornment, InputLabel, TextField } from '@mui/material';

const CustomInput = ({
  label,
  name,
  value,
  onChange,
  placeholder = '',
  size = 'medium',
  rows,
  multiline = false,
  required = false,
  type = 'text',
  startIcon,
  ...props
}) => {
  return (
    <>
      {label && (
        <InputLabel
          htmlFor={name}
          sx={{
            color: '#2B2B2B',
            fontSize: '13px',
            fontWeight: 600,
            marginBottom: '4px',
          }}
        >
          {label} {required && <span style={{ color: '#FF4C5E' }}>*</span>}
        </InputLabel>
      )}
      <TextField
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        size={size}
        value={value}
        onChange={onChange}
        fullWidth
        multiline={multiline}
        rows={rows}
        required={required}
        FormHelperTextProps={{
        style:{
          fontSize:'10px'
        }
        }}
        InputProps={{
          style: {
            fontSize: '13px',
            borderRadius: '8px',
            height: multiline ? 'auto' : '50px',
          },
          startAdornment:<InputAdornment position='start'>{startIcon}</InputAdornment>
        }}
        {...props}
      />
    </>
  );
};

export default CustomInput;
